// extracted by mini-css-extract-plugin
module.exports = {"pageMain":"styles_pageMain__Dv_VK"};